import S from './Button.module.scss';

export const btnColors = {
  primary: S.color_primary,
  secondary: S.color_secondary,
  transparent: S.color_transparent,
};

export const btnTypes = {
  default: S.btn_default,
  reset: S.btn_reset,
  apply: S.btn_apply,
  category: S.btn_category,
  steps: S.btn_steps,
  catalog: S.btn_catalog,
};
